import React, { memo, useCallback, useRef, useState } from "react";
import cx from "classnames";
import { map } from "lodash";
import ThumbNail from "../../components/thumbNail/ThumbNail";
import Icons from "../../components/icons";
import { ICONS } from "../../constants/icons.constants";
import { MEDIA_URL } from "../../axios";
import musicPlayerStore from "../../zustand/musicPlayer.store";
import likedSongsStore from "../../zustand/likedSong.store";
import styles from "./MobileSongList.module.scss";

const EqBars = () => (
  <div className={styles.eqBars}>
    <span /><span /><span />
  </div>
);

const MobileSongItem = memo(
  ({ song, index, isCurrentSong, isPlaying, isLiked, onClick, onLikeClick }) => {
    return (
      <div
        className={cx(styles.item, { [styles.active]: isCurrentSong })}
        onClick={() => onClick(index)}
      >
        <div className={styles.thumb}>
          {isCurrentSong && isPlaying ? (
            <div className={styles.thumbOverlay}>
              <ThumbNail
                name={song.title}
                color={song.color}
                imgSrc={`${MEDIA_URL}/songs_images/${song.imageFileName}`}
                hasImage={!!song.imageFileName}
                imageFileName={song.imageFileName}
              />
              <EqBars />
            </div>
          ) : (
            <ThumbNail
              name={song.title}
              color={song.color}
              imgSrc={`${MEDIA_URL}/songs_images/${song.imageFileName}`}
              hasImage={!!song.imageFileName}
              imageFileName={song.imageFileName}
            />
          )}
        </div>
        <div className={styles.songInfo}>
          <p className={cx(styles.songTitle, { [styles.nowPlaying]: isCurrentSong })}>{song.title}</p>
          <p className={styles.songArtist}>{song.artist}</p>
        </div>
        <button
          className={cx(styles.likeBtn, { [styles.liked]: isLiked })}
          onClick={(e) => {
            e.stopPropagation();
            onLikeClick(song, isLiked);
          }}
        >
          <Icons type={ICONS.LIKE_SONG_LIST} />
        </button>
      </div>
    );
  }
);

const MobileSongList = ({ songs, onSongClick, onLikeClick }) => {
  const { currentSongIndex, isPlaying } = musicPlayerStore((state) => ({
    currentSongIndex: state.currentSongIndex,
    isPlaying: state.isPlaying,
  }));
  const { songs: likedSongs } = likedSongsStore((state) => ({
    songs: state.songs,
  }));

  const [visibleCount, setVisibleCount] = useState(20);
  const observer = useRef();

  const lastItemRef = useCallback((node) => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setVisibleCount((prev) => prev + 15);
      }
    });
    if (node) observer.current.observe(node);
  }, []);

  if (!songs?.length) return null;

  return (
    <div className={styles.list}>
      {map(songs.slice(0, visibleCount), (song, index) => {
        const isLast = index === visibleCount - 1;
        return (
          <div key={song.id + index} ref={isLast ? lastItemRef : null}>
            <MobileSongItem
              song={song}
              index={index}
              isCurrentSong={index === currentSongIndex}
              isPlaying={isPlaying}
              isLiked={!!likedSongs?.[song.id]}
              onClick={onSongClick}
              onLikeClick={onLikeClick}
            />
          </div>
        );
      })}
    </div>
  );
};

export default memo(MobileSongList);
